module.exports = __webpack_public_path__ + "img/Ciculo-de-Texto.5e73bab5.png";